import React from 'react';
import { Trophy } from 'lucide-react';
import { getForumScoreBreakdown } from '../../utils/forumScore';

interface Props {
  topics: number;
  posts: number;
  members: number;
  foundedYear: number;
  /** Düzenleme modunda kayıtlı skor (karşılaştırma için) */
  savedScore?: number | null;
}

const ForumScorePreview: React.FC<Props> = ({ topics, posts, members, foundedYear, savedScore }) => {
  const { score, raw, year, topics: t, posts: p, members: m } = getForumScoreBreakdown(
    topics,
    posts,
    members,
    foundedYear
  );

  const showDelta = savedScore != null && savedScore !== score;
  const delta = showDelta ? score - savedScore! : 0;

  return (
    <div className="rounded-lg border border-indigo-200 bg-indigo-50 dark:bg-indigo-950/40 dark:border-indigo-800 px-4 py-3">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <ScoreHeader score={score} showDelta={showDelta} savedScore={savedScore} delta={delta} />
      </div>
      <p className="mt-2 text-xs font-mono text-indigo-800/90 dark:text-indigo-200/90">
        ({t.toLocaleString('tr-TR')}×5 + {p.toLocaleString('tr-TR')}×2 + {m.toLocaleString('tr-TR')}×10)
        {year > 0 ? (
          <>
            {' '}
            ÷ {year} = <strong>{score.toLocaleString('tr-TR')}</strong>
          </>
        ) : (
          ' — geçerli kuruluş yılı girin'
        )}
        {year > 0 && (
          <span className="opacity-70"> (ham: {raw.toLocaleString('tr-TR')})</span>
        )}
      </p>
    </div>
  );
};

function ScoreHeader({
  score,
  showDelta,
  savedScore,
  delta,
}: {
  score: number;
  showDelta: boolean;
  savedScore?: number | null;
  delta: number;
}) {
  return (
    <>
      <div className="flex items-center gap-2 text-indigo-900 dark:text-indigo-100">
        <Trophy size={18} className="text-amber-500 shrink-0" />
        <span className="text-sm font-medium">Skor önizlemesi</span>
        <span className="text-xl font-bold tabular-nums">{score.toLocaleString('tr-TR')}</span>
      </div>
      {showDelta && savedScore != null && (
        <p className="text-xs text-indigo-700 dark:text-indigo-300">
          Kayıtlı: {savedScore.toLocaleString('tr-TR')}
          <span
            className={`ml-2 font-semibold ${
              delta > 0 ? 'text-emerald-600 dark:text-emerald-400' : 'text-red-600 dark:text-red-400'
            }`}
          >
            ({delta > 0 ? '+' : ''}
            {delta.toLocaleString('tr-TR')})
          </span>
        </p>
      )}
    </>
  );
}

export default ForumScorePreview;
